<template>
  <div class="flex h-12 w-full items-center gap-2 border-b border-neutral-200 bg-white px-3 md:hidden">
    <div class="flex min-w-0 flex-1 items-center gap-3">
      <a
        class="flex min-w-0 cursor-pointer items-center gap-2"
        :data-test="data_test_label"
        @click="emit('open-sidebar')"
      >
        <FontAwesomeIcon
          :icon="['far', 'bars']"
          size="lg"
          class="shrink-0 text-gray-600"
        />
        <Avatar
          class="shrink-0"
          :src="avatar_src"
          :username="label"
          :format="avatar_format"
          size="32"
        />
      </a>

      <slot name="pill" />
    </div>

    <NotificationsToggleIcon class="shrink-0" />

    <TheProfileMenu class="shrink-0" />

    <slot name="menus" />
  </div>
</template>

<script setup>
import NotificationsToggleIcon from '@/app/shared_components/navbar/notifications/TheNotificationsToggleIcon.vue';
import TheProfileMenu from '@/app/shared_components/navbar/TheProfileMenu.vue';

defineProps({
  label: { type: String, default: '' },
  avatar_src: { type: String, default: undefined },
  avatar_format: { type: String, default: undefined },
  data_test_label: { type: String, default: null },
});

const emit = defineEmits(['open-sidebar']);
</script>
